// return the promise so the called could apply .then method
// Need some cleanup here, such as unified url and error messages
import { getToken, getDataServer, logger, jsonPP } from '../views/utility/utility'
// import axios from './axios'
import swal from 'sweetalert'
import swal2 from 'sweetalert2'
import { isEmpty, isNull } from 'lodash'
import axios from 'axios'
const dataServer = getDataServer()

const getRoles = async () => {
  const query = `
    query Roles {
      roles {
        id
        name
      }
    }
  `
  return await retrieveDataUsingGraphQL(query)
    .then((response) => {
      if (response.ok) {
        return response.json()
      } else
        return response.json().then((error) => {
          throw new Error(error.errmsg)
        })
    })
    .then(({ data }) => {
      logger('generalServiceAPI - getRoles:', data)
      return data.roles
    })
    .catch((e) => {
      swal2.fire({ title: 'error', html: e.message, type: 'error' })
    })
}
export const fileDelete = (path, file) => {
  return fetch(dataServer + `/file/${path}/${file}`, {
    method: 'DELETE',
    headers: {
      authorization: getToken(),
      accept: 'application/json',
    },
  })
    .then((response) => {
      if (response.ok || response.status < 500) {
        return response.json()
      } else {
        throw new Error(response.statusText)
      }
    })
    .catch((e) => {
      logger('[generalServiceAPI][fileDelete]: ', e, true)
      swal2.fire({ title: 'error', html: e.message, type: 'error' })
    })
}

//sudo sysctl net.ipv6.conf.all.disable_ipv6=1
//sudo sysctl net.ipv6.conf.default.disable_ipv6=1
export const giveMeAJoke = () => {
  return fetch(
    'https://icanhazdadjoke.com',
    // url: 'https://www.google.com',
    {
      method: 'GET',
      headers: {
        accept: 'application/json',
      },
    }
  )
    .then((response) => {
      logger('[generalServiceAPI][giveMeAJoke]: ', response)
      return response.json()
    })
    .catch((e) => {
      logger('[generalServiceAPI][giveMeAJoke]: ', e, true)
      // don't populate dialogue for a joke, :)
      //swal2.fire({title:'error', html:e.message, type:'error'})
    })
}
//
//https://gist.github.com/javilobo8/097c30a233786be52070986d8cdb1743
// this may not work, it used to be tested out with axios and it has url in the object as well
// changed to fetch silently (without test), found out that fetch need the url outside of option object
export const fileDownload = (path, file) => {
  logger(`${dataServer}/file/${path}/` + encodeURIComponent(file))
  return axios({
    url: `${dataServer}/file/${path}/` + encodeURIComponent(file),
    method: 'GET',
    headers: {
      authorization: getToken(),
    },
    responseType: 'blob',
  })
    .then((response) => {
      logger('[generalServiceAPI][fileDownload]:', response)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', file)
      document.body.appendChild(link)
      link.click()
      // document.body.revokeObjectURL(link)
    })
    .catch((e) => {
      logger('[generalServiceAPI][fileDownload]: ', e, true)
      swal2.fire({ title: 'error', html: e.message, type: 'error' })
    })
}
// export const fileDownload = (path, file) => {
//   return (
//     fetch(dataServer + `/file/${path}/${file}`, {
//       method: 'GET',
//       headers: {
//         authorization: getToken()
//       }
//     })
//       .then(response => {
//         console.log(response)
//         if (response.ok || response.status < 500) {
//           return response.json()
//         } else {
//           throw new Error(response.statusText)
//         }
//       })
//       .catch(e => {
//         swal2.fire({title:'error', html:e.message, type:'error'})
//       })
//   )
// }
//preAuth is used to provide token if existed to avoid regular user/pass auth
export const preAuth = () => {
  // console.log(dataServer)
  return fetch(dataServer + '/login', {
    method: 'POST',
    headers: {
      authorization: getToken(),
      accept: 'application/json',
    },
  }).catch((e) => logger('[generalServiceAPI][preAuth]: ', e, true))
}
export const authenticate = (authData) => {
  //return the promise to have the upper layer handle the rest since it has the app context already
  // console.log(authData)
  return fetch(dataServer + '/login', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      accept: 'application/json',
    },
    body: JSON.stringify(authData),
  })
  // .then(response => response.json())
  // .then(userData => userData)
  // .catch(e => {
  //   console.log(e.message)
  // })
}
export const resetPassword = (data) => {
  const { username, currentPassword: password } = data
  const authData = { username, password }
  const dataToUpdate = {
    tableName: 'users',
    id: data.id,
    password: data.newPassword,
  }
  return authenticate(authData)
    .then((response) => {
      // console.log(response)
      if (response.ok || response.status < 500) {
        return response.json()
      } else {
        throw new Error(response.statusText)
      }
    })
    .then((data) => {
      // console.log(data)
      if (data.code === 0) {
        return updateOne(dataToUpdate)
      } else {
        throw new Error(data.message)
      }
    })
    .catch((e) => {
      localStorage.removeItem('token')
      // console.log(e.message)
    })
}
export const retrieveDataUsingGraphQL = (query, variables) => {
  logger('[generalServiceAPI][retrieveDataUsingGraphQL]:', { query, variables })
  return fetch(dataServer + '/graphql', {
    method: 'POST',
    headers: new Headers({
      Accept: 'application/json',
      'Content-type': 'application/json',
      authorization: getToken(),
    }),
    body: JSON.stringify({ query, variables }),
  }).catch((e) => {
    //swal2.fire({ title: 'Error', text: 'Data server is out of reach', type: 'error' })
    //logger('[generalServiceAPI]: [retrieveDataUsingGraphQL]: ', e.message)
    logger('[generalServiceAPI][retrieveDataUsingGraphQL]: ', jsonPP({ error: e.message, query, variables }))
  })
}
export const retrieveSomeRoutes = (variables) => {
  const routesQuery = `
    query SomeRoutes($id: ID,$typeOfApplicationId: Int, $companyId: ID, $departments:[ID], $expenseTypeId: ID, $expenseOrProcurement: String, $pageNumber: Int, $pageSize: Int, $filtered: String, $sorted: String, $source: String){
      someRoutes(id:$id, typeOfApplicationId:$typeOfApplicationId, companyId: $companyId, departments: $departments, expenseTypeId: $expenseTypeId, expenseOrProcurement: $expenseOrProcurement, pageNumber:$pageNumber, pageSize:$pageSize, filtered:$filtered, sorted: $sorted, source: $source) {
        pages
        routes{
          id
          typeOfApplicationId
          typeOfApplication {
            name
            short
          }
          expenseTypeId
          expenseType {
            name
          }
          expenseOrProcurement
          companyId
          company {
            name
          }
          departments{
            id
            name
          }
          unconditionallyRoute
          signingPathId
          signingPath {
            name
            numberOfLevels
          }
          levelToFinish
          routingConditions {
            displayName
            type
            name
            minValue
            maxValue
            value
            dropdownId
          }
        }
      }
    }
  `
  const { filtered, sorted, ...rest } = variables
  return (
    // retrieveDataUsingGraphQL(routesQuery, { ...rest, filtered, sorted })
    retrieveDataUsingGraphQL(routesQuery, { ...rest, filtered: JSON.stringify(filtered), sorted: JSON.stringify(sorted) })
      .then((response) => {
        if (response.ok) {
          return response.json()
        }
        // return this promise otherwise will get unhandled reject handling error
        // when reponse is not ok, it means something wrong on DB side and the error return in a json
        // only parse out the errmsg here
        else
          return response.json().then((error) => {
            throw new Error(error.errmsg)
          })
      })
      .catch((e) => {
        swal2.fire({ title: 'Error in retriveSomeRoutes', html: JSON.stringify(e), type: 'error' })
      })
  )
}

export const retrieveRoutes = (variables) => {
  const routesQuery = `
    query Routes($typeOfApplicationId: Int!, $companyId: ID, $departments:[ID], $expenseTypeId: ID, $expenseOrProcurement: String, $pageNumber: Int, $pageSize: Int, $filtered:String){
      routes(typeOfApplicationId:$typeOfApplicationId, companyId: $companyId, departments: $departments, expenseTypeId: $expenseTypeId, expenseOrProcurement: $expenseOrProcurement, pageNumber:$pageNumber, pageSize:$pageSize, filtered:$filtered) {
        typeOfApplicationId
        companyId
        departments{
          id
          name
        }
        unconditionallyRoute
        signingPathId
        signingPath{
          name
          id
        }
        levelToFinish
        routingConditions {
          displayName
          type
          name
          minValue
          maxValue
          value
          dropdownId
        }
      }
    }
  `
  return retrieveDataUsingGraphQL(routesQuery, variables)
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
      // return this promise otherwise will get unhandled reject handling error
      // when reponse is not ok, it means something wrong on DB side and the error return in a json
      // only parse out the errmsg here
      else
        return response.json().then((error) => {
          throw new Error(error.errmsg)
        })
    })
    .catch((e) => {
      swal2.fire({ title: 'error', html: e.message, type: 'error' })
    })
}
export const retrieveBoundPath = (variables) => {
  const pathBindingQuery = `
    query PathBinding($typeOfApplicationId: Int, $companyId: ID, $departments:[ID],$expenseTypeId: ID, $source: String, $expenseOrProcurement: String){
        pathBinding(typeOfApplicationId:$typeOfApplicationId, companyId:$companyId, departments: $departments,expenseTypeId:$expenseTypeId, source:$source, expenseOrProcurement:$expenseOrProcurement){
          typeOfApplicationId
          companyId
          departments{
            id
            name
          }
          signingPathId
          expenseTypeId
          signingPath {
            name
            id
            numberOfLevels
            levels {
              level
              approverType
              approverGroupId
              approverGroupName
              currentApprover{ 
                id
                position{
                  id
                  name
                }
                name
                email
              }
            }          
          }
        }
    }
  `

  return retrieveDataUsingGraphQL(pathBindingQuery, variables)
    .then((response) => {
      console.log(response)
      if (response.ok) {
        // console.log(response.json())
        return response.json()
      }
      // return this promise otherwise will get unhandled reject handling error
      // when reponse is not ok, it means something wrong on DB side and the error return in a json
      // only parse out the errmsg here
      else
        return response.json().then((error) => {
          throw new Error(error.errmsg)
        })
    })
    .catch((e) => {
      logger('[generalServiceAPI][retrieveDataUsingGraphQL]: ', e, true)
      swal2.fire({ title: 'error', html: e.message, type: 'error' })
    })
}
export const isUserInGroup = async (userId, groupName) => {
  const QUERY = `
    query UserGroupByName($groupName: String){
        userGroupByName(name:$groupName){
          groupMembers {
            id
          }
        }
    }
  `

  const {
    data: { userGroupByName },
  } = await retrieveDataUsingGraphQL(QUERY, { groupName })
    .then((response) => {
      if (response.ok) {
        // console.log(response.json())
        return response.json()
      } else
        return response.json().then((error) => {
          throw new Error(error.errmsg)
        })
    })
    .catch((e) => {
      logger('[generalServiceAPI][isUserInGroup]: ', e, true)
      swal2.fire({ title: 'Error in isUserInGroup', html: e.message, type: 'error' })
    })
  if (isEmpty(userGroupByName)) {
    swal2.fire({ title: 'Warning[isUserInGroup]', html: `No group called ${groupName} has been definited yet.`, type: 'warning' })
    return false
  }
  logger(`[generalServiceAPI][isUserInGroup]:`, { userId, userGroupByName })
  return userGroupByName.groupMembers.map((m) => m.id).includes(userId)
}
// expecting a signingPath Object and an initiatorId
export const signerResolver = async (signingPath, initiatorId) => {
  // 应该传入 lastLevelToSign, 这样就只对需要他和节点解析
  logger('[signerResolver][entry]:', { signingPath })
  let signers = []
  let previousUserId
  for (var key = 0, len = signingPath.levels.length; key < len; key++) {
    // 每轮清空 user object
    let user
    let level = signingPath.levels[key]
    try {
      if (level.approverType === '1') {
        // 寻找 manager
        let userToFindManagerFor
        if (key === 0) {
          userToFindManagerFor = initiatorId
        } else if (previousUserId) {
          userToFindManagerFor = previousUserId
        } else {
        }
        if (isEmpty(userToFindManagerFor)) {
          user = {
            position: 'N/A',
            error: `Missing previous signer`,
          }
        } else {
          const data = await retrieveUserInfo({ id: userToFindManagerFor })
          logger('[signerResolver][applicant info]:', { key, previousUserId, userToFindManagerFor, data })
          // 如果申请人信息不存在（防错而已） 或者 没有配置了manager
          if (!data || !data.data.user.reportTo) {
            user = {
              position: 'N/A',
              error: `${data.data.user.name} needs a manager`,
            }
          } else {
            user = data.data.user.reportTo
          }
        }
      } else {
        // 这个应该早找到了， 因为这个跟申请人没关系
        user = level.currentApprover
      }

      // 如果没有找到申请人， 这个包括部门或组内没有人的情况
      if (!user) {
        user = {
          position: 'N/A',
          error: `no one available in ${level.approverGroupName}`,
        }
      }
      const { position, name, id, email } = user //this won't work for existing application whose initiator may not be the current one
      previousUserId = id
      logger('[signerResolver][applicant info]:', { key, previousUserId, user })
      const signer = {
        id,
        level: level.level,
        position: position ? position.name : '',
        fullName: name,
        email,
        chineseName: '',
      }
      signers.push(signer)
    } catch (e) {
      swal2.fire({ title: 'Error in signerResolver', html: e.message, type: 'error' })
      return []
    }
  }
  logger('[signerResolver][singers]:', { signers })
  return signers
}
// get the fixed path
export const getLastSignerForTOABTA = async (groupName) => {
  const query = `
    query userGroup($groupName: String!){
      userGroupByName(name: $groupName) {
        id
        groupMembers {
          id
          details {
            id
            position {
              name
            }
            name
            email
          }
        }
      }
    }
  `

  try {
    const response = await fetch(dataServer + '/graphql', {
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json',
        'Content-type': 'application/json',
        authorization: getToken(),
      }),
      body: JSON.stringify({ query, variables: { groupName } }),
    })
      .then((response) => {
        if (response.ok) {
          return response.json()
        } else
          return response.json().then((error) => {
            throw new Error(error.errmsg)
          })
      })
      .catch((e) => {
        swal2.fire({ title: 'Error in retriveSomeRoutes', html: JSON.stringify(e), type: 'error' })
        return {}
      })

    logger('[getLastSignerForTOABTA][data]:', { response })
    const { userGroupByName } = response.data
    if (!isEmpty(userGroupByName)) {
      return userGroupByName.groupMembers[0].details
    } else {
      return {}
    }
  } catch (e) {
    swal2.fire({ title: 'Error in getLastSignerForTOABTA', html: e.message, type: 'error' })
    return {}
  }
}
export const retrieveUserInfo = async (variables) => {
  const query = `
  query user($id: ID!){
    user(id: $id) {
      id
      username
      firstname
      lastname
      name
      email
      alternativeEmail
      department {
        id
        name
      }
      company {
        id
        name
      }
      position{
        id
        name
      }
      roleID
      role{
        id
        name
      }
      reportTo {
        id
        name
        email
        position{
          id
          name
        }
      }
      weight
      dashboardTheme
      description
    }
  }
`

  // return fetch(dataServer + '/graphql', {
  //   method: 'POST',
  //   headers: new Headers({
  //     Accept: 'application/json',
  //     'Content-type': 'application/json',
  //     authorization: getToken()
  //   }),
  //   body: JSON.stringify({ query, variables })
  // })
  //   .then(response => {
  //     return response.json()
  //   })
  //   .catch(e => {
  //     throw new Error(e.message)
  //   })

  try {
    const response = await fetch(dataServer + '/graphql', {
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json',
        'Content-type': 'application/json',
        authorization: getToken(),
      }),
      body: JSON.stringify({ query, variables }),
    })
    return await response.json()
  } catch (e) {
    swal2.fire({ title: 'Error in xxx', html: e.message, type: 'error' })
  }
}
export const retrieveUserSettings = (variables) => {
  const query = `
  query user($id: ID!){
    user(id: $id) {
      id
      isOnVacation
      emailOption
      dashboardTheme
      delegate{
        id
        name
        email
      }
    }
  }
`

  return fetch(dataServer + '/graphql', {
    method: 'POST',
    headers: new Headers({
      Accept: 'application/json',
      'Content-type': 'application/json',
      authorization: getToken(),
    }),
    body: JSON.stringify({ query, variables }),
  })
    .then((response) => {
      return response.json()
    })
    .catch((e) => {
      logger('[generalServiceAPI][retrieveUserSettings]: ', e.message, true)
    })
}
export const getAll = (data) => {
  const { tableName } = data
  return fetch(dataServer + `/data/${tableName}`, {
    method: 'GET',
    headers: {
      accept: 'application/json',
    },
  }).catch((e) => {
    alert(e.message)
  })
}

export const deleteOne = (data) => {
  const { id, tableName } = data
  return fetch(dataServer + `/data/${tableName}/?_id=${id}`, {
    method: 'DELETE',
    headers: {
      accept: 'application/json',
      authorization: getToken(),
    },
  }).catch((e) => {
    logger('[generalServiceAPI][deleteOne]: ', e.message, true)
  })
}

export const insertOne = (data) => {
  const { id, tableName, ...rest } = data
  // mode: no-cors will never work, since browser won't let you change headers for a cor call anyway
  // To make to this work needs a proxy setting on client app
  // Need to stringify the json object to the string
  // console.log(rest)
  return fetch(dataServer + `/data/${tableName}`, {
    method: 'POST',
    headers: new Headers({
      Accept: 'application/json',
      'Content-type': 'application/json',
      authorization: getToken(),
    }),
    body: JSON.stringify(rest),
  }).catch((e) => {
    logger('[generalServiceAPI][insertOne]: ', e.message, true)
    throw new Error('Failed to create a new record.')
  })
}

//Special handling here, it's too deep, hard to automatically pick up the fileds ending with 'Id'
export const insertSigningPath = (data) => {
  const { id, tableName, ...rest } = data
  return fetch(dataServer + `/special/data/${tableName}`, {
    method: 'POST',
    headers: new Headers({
      Accept: 'application/json',
      'Content-type': 'application/json',
      authorization: getToken(),
    }),
    body: JSON.stringify(rest),
  }).catch((e) => {
    logger('[generalServiceAPI][insertSigningPath]: ', e.message, true)
    throw new Error('Failed to create a new record.')
  })
}

export const updateOne = (data) => {
  const { id, tableName, ...rest } = data
  // console.log(`Updating ${tableName} on ${id} with ${JSON.stringify(rest)}`)
  return fetch(dataServer + `/data/${tableName}/?_id=${id}`, {
    method: 'PUT',
    headers: new Headers({
      Accept: 'application/json',
      'Content-type': 'application/json',
      authorization: getToken(),
    }),
    body: JSON.stringify(rest),
  }).catch((e) => {
    logger('[generalServiceAPI][updateOne]: ', e.message, true)
  })
}

export const finishPaymentForApplication = (data) => {
  const { id, tableName, refetch, archived } = data
  swal({
    title: 'Are you sure?',
    text: 'Once the application is marked as finished, it will dispear from your view and can only be accessed by administrator!',
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  }).then((markAsFinished) => {
    if (markAsFinished) {
      updateOne({ tableName, id, archived })
        .then((response) => {
          // console.log(response)
          if (response.ok) {
            swal2.fire({ title: 'Success', html: 'This record has beend updated', type: 'success', timer: 2000 })
            if (refetch) refetch()
          } else
            swal(response.url, {
              icon: 'error',
            })
        })
        .catch((e) => swal2.fire({ title: 'Error', html: `General API throw an error: ${e}`, type: 'error' }))
    } else {
      //swal("Your imaginary file is safe!");
    }
  })
}

export const deleteRecord = (data) => {
  const { id, tableName, refetch } = data
  swal({
    title: 'Are you sure?',
    text: 'Once deleted, you will not be able to recover this record!',
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  }).then((willDelete) => {
    if (willDelete) {
      deleteOne({ tableName, id })
        .then((response) => {
          // console.log(response)
          if (response.ok) {
            swal2.fire({ title: 'Success', html: 'This record has beend deleted', type: 'success', timer: 2000 })
            if (refetch) refetch()
          } else
            swal(response.url, {
              icon: 'error',
            })
        })
        .catch((e) => swal2.fire({ title: 'Error', html: `General API throw an error: ${e}`, type: 'error' }))
    } else {
      //swal("Your imaginary file is safe!");
    }
  })
}

export const signingFlowHandling = (data) => {
  logger('[generalServiceAPI][signingFlowHandling][0]: ', data)
  return fetch(dataServer + `/application/${data.action}`, {
    method: 'POST',
    headers: new Headers({
      Accept: 'application/json',
      'Content-type': 'application/json',
      authorization: getToken(),
    }),
    body: JSON.stringify(data),
  })
    .then((response) => {
      logger('[generalServiceAPI][signingFlowHandling][1]:', response)
      if (response.ok) {
        return response.json()
      } else {
        logger('[generalServiceAPI][signingFlowHandling][2]: ', response.status)
        swal2.fire({ title: 'Error', html: response.statusText, type: 'error', timer: 2000 })
        // this return doesn't do much other than making the direct caller to this happy
        return response.json()
      }
    })
    .catch((e) => {
      logger('[generalServiceAPI][signingFlowHandling][3]:', e, true) //error report
      swal2.fire({ title: 'Error', html: e, type: 'error', timer: 2000 })
      // swal('Error in general service', e, 'error')
    })
}

/*
  Usage: universal function to approve or reject an application, other actions can be added if there is any
  Args:  
    approveData: {
      action,  // currently support approve, reject
      application
    }
  Notes: the following moved into backend
    const currentSigner = application.signers[application.activeStep]
    const nextSigner = application.activeStep < application.signers.length - 1 ? application.signers[application.activeStep + 1] : {}

  Note: caller can override the default action
*/
export const submitApplication = (flowData) => signingFlowHandling({ action: 'submit', ...flowData })
export const approveApplication = (flowData) => signingFlowHandling({ action: 'approve', ...flowData })
export const rejectApplication = (flowData) => signingFlowHandling({ action: 'reject', ...flowData })
export const adjustContributorsOfApplication = (flowData) => signingFlowHandling({ action: 'invite', ...flowData })

/*
  Usage: universal wrapper for approve and reject
  Args: 
  Note: caller can override the default action
*/
export const handleApprove = ({ application, reason, refresh, pullingNumbers }) => {
  // console.log(application)
  approveApplication({ application, reason }).then((data) => {
    // console.log(data)
    if (data.code === 0) {
      const {
        message: { activeStep, lastLevelToSign},
      } = data
      swal2.fire({ title: 'Success', html: 'Application is approved!', type: 'success', timer: 2000 }).then(() => {
        // logger(`tttt: `, { s: application.signers, activeStep })
        if (application.signers.slice(0, activeStep).filter((signer) => activeStep<lastLevelToSign && signer.id === application.signers[activeStep].id).length > 0) {
          // logger(`tttt: find match approve 2nd time`, data.message)
          const { message } = data
          message.id = message._id
          handleApprove({
            application: message,
            reason: `${application.signers[activeStep].fullName} has approved this request previously, so auto-approvement is assumed.`,
            refresh,
            pullingNumbers,
          })
        }
        // if (!isEmpty(refresh)) refresh(application.id)
        // if (!isEmpty(pullingNumbers)) pullingNumbers()
        refresh(application.id)
        pullingNumbers()
      })
    } else {
      swal2.fire({ title: 'Error in handleApprove', html: data.message, type: 'error', timer: 2000 })
    }
  })
}

export const handleReject = ({ application, refresh, pullingNumbers }) => {
  swal2
    .fire({
      title: 'Confirm',
      text: 'Please provide a reason if you really want to reject this application',
      input: 'text',
      inputAttributes: {},
      showCancelButton: true,
    })
    .then((reason) => {
      logger('[SigingFlow][]:', { reason })
      // signingFlowHandling({ ...rejectData, reason: reason.value }).
      rejectApplication({ application, reason: reason.value }).then((data) => {
        if (data.code === 0) {
          swal2.fire({ title: 'Success', html: 'Application is rejected!', type: 'warning', timer: 2000 }).then(() => {
            refresh(application.id)
            pullingNumbers()
          })
        } else {
          swal2.fire({ title: 'Error', html: data.message, type: 'error', timer: 2000 })
        }
      })
    })
}

// this function will return the max level of approval assuming all the fields of condition have their values in values object
// it will be called in the render to decide how the signer component should be rendered
// it will be called also before save, so only the necessary signer will be recorded in the signing path
export const getHighestLevelOfSingers = (data) => {
  // this function only look into a feild called amount
  // it will also take care of excahngeRate
  logger('[generalServiceAPI][getHighestLevelOfSingers]: ', data)
  if (isEmpty(data.routes)) return data.lastLevelToSign
  if (data.routes.length === 1 && data.routes[0].unconditionallyRoute) return data.signers.length
  try {
    let finalLevel = Math.max(
      // ... here is to expand the return vlaue
      ...data.routes.map((r, key) => {
        if (r.unconditionallyRoute) {
          return r.levelToFinish
        } else {
          return r.routingConditions.reduce((ifAllConditionMet, fieldOfCondition) => {
            let maxv, minv
            if (isNull(fieldOfCondition.maxValue)) {
              maxv = 999999999999
            } else {
              maxv = fieldOfCondition.maxValue
            }
            if (isNull(fieldOfCondition.minValue)) {
              minv = 0
            } else {
              minv = fieldOfCondition.minValue
            }
            if (maxv < minv) {
              throw new Error(`Max value for amount is less than the Min value, please check.`)
            } else {
              const USD_Amount = parseFloat(data['amount'] / data['exchangeRate'])
              // console.log({ input: data['amount'], USD_Amount, ex: data['exchangeRate'] })
              return ifAllConditionMet && USD_Amount >= minv && USD_Amount < maxv
            }
          }, true)
            ? r.levelToFinish
            : 0
        }
      })
    )
    // this is the case where higher order route is created but lower order route is missing out, so this can say last level is 10, but there is only 2 routes
    if (data.signers.length < finalLevel) throw new Error('Missing lower order routes.')
    // this.state.data.signers.map(singer => {
    //   if (!singer.fullName) throw new Error(`Did not find an available singer for level ${singer.level}`)
    // })
    return finalLevel
  } catch (e) {
    logger('[generalServiceAPI][getHighestLevelOfSingers]: ', e, true) //error report
    swal2.fire({ title: 'error', html: e.message, type: 'error' })
    return -2 //differentiate with initial value
  }
}
export const getLastLevelOfSingerBasedUponWeight = (weight, numberOfSigners) => {
  if (parseInt(weight) > numberOfSigners) {
    swal2.fire({ title: 'Error in user settings', html: "User's weight is set too large.", type: 'error' })
    return -1
  }
  return parseInt(weight)
}
export const getHighestLevelOfSingers_ORIGINAL_FOR_ALL_PURPOSE = (data) => {
  logger('[generalServiceAPI][getHighestLevelOfSingers]: ', data)
  // logic here
  // 1. go through all the routes in the first cycle
  // 2.1 return the levelToFinish if set the unconditionally route skipping all conditions
  // 2.1.1 *** should validate there is only one unconditional route for a signingPath ***
  // 2.2 go through all conditions in each route, return true only if all conditions are met,
  //     so the inittial value needs to be true
  // 2.3 when all condistions are met for this route, return the level otherwise return 0
  // 3. once all routes are checked, an array will be returned from map function, the item is possibly the level if route is met
  // 4. return the max one if there are multiple values greater than 0 - and it shouldn't

  // reference of a route structure
  // "routes": [
  //   {
  //      "typeOfApplicationId": 0,
  //      "companyId": "5bf11f21cde7bf1cf76e02ff",
  //      "unconditionallyRoute": false,
  //      "signingPathId": "5c4a7f291666002bcca0da9a",
  //      "levelToFinish": 1,
  //      "routingConditions": [
  //         {
  //            "displayName": "Amount",
  //            "type": "number",
  //            "name": "amount",
  //            "minValue": 0,
  //            "maxValue": 500,
  //            "value": null,
  //            "dropdownId": null
  //         }
  //       ]
  //   }
  // ]

  // when routes is empty, all UI connecting to change() function is gonna trigger error without this
  // was set to 0, but it will override this value for existing application
  if (isEmpty(data.routes)) return data.lastLevelToSign
  if (data.routes.length === 1 && data.routes[0].unconditionallyRoute) return data.signers.length
  try {
    let finalLevel = Math.max(
      // ... here is to expand the return vlaue
      ...data.routes.map((r, key) => {
        if (r.unconditionallyRoute) {
          return r.levelToFinish
        } else {
          return r.routingConditions.reduce((ifAllConditionMet, fieldOfCondition) => {
            switch (fieldOfCondition.type) {
              case 'number':
                let maxv, minv
                if (isNull(fieldOfCondition.maxValue)) {
                  maxv = 999999999999
                  // throw new Error(`Max value for ${fieldOfCondition.name} is missing in one route, please check.`)
                } else {
                  maxv = fieldOfCondition.maxValue
                }
                if (isNull(fieldOfCondition.minValue)) {
                  minv = 0
                  // throw new Error(`Min value for ${fieldOfCondition.name} is missing in one route, please check.`)
                } else {
                  minv = fieldOfCondition.minValue
                }
                if (maxv < minv) {
                  //return ifAllConditionMet && data[fieldOfCondition.name] >= fieldOfCondition.minValue
                  throw new Error(`Max value for ${fieldOfCondition.name} is less than the Min value, please check.`)
                } else {
                  //console.log(data[fieldOfCondition.name], minv, maxv)
                  return ifAllConditionMet && data[fieldOfCondition.name] >= minv && data[fieldOfCondition.name] < maxv
                }

              case 'select':
                // return ifAllConditionMet && values[fieldOfCondition.name] === fieldOfCondition.dropdownId
                // console.log(fieldOfCondition)
                return ifAllConditionMet && true
              default:
                return false
            }
          }, true)
            ? r.levelToFinish
            : 0
        }
      })
    )
    // this is the case where higher order route is created but lower order route is missing out, so this can say last level is 10, but there is only 2 routes
    if (data.signers.length < finalLevel) throw new Error('Missing lower order routes.')
    // this.state.data.signers.map(singer => {
    //   if (!singer.fullName) throw new Error(`Did not find an available singer for level ${singer.level}`)
    // })
    return finalLevel
  } catch (e) {
    logger('[generalServiceAPI][getHighestLevelOfSingers]: ', e, true) //error report
    swal2.fire({ title: 'error', html: e.message, type: 'error' })
    return -2 //differentiate with initial value
  }
}
export const UserEnum = getRoles()
// fetch(myRequest).then(response => {
//   const contentType = response.headers.get("content-type");
//   if (contentType && contentType.indexOf("application/json") !== -1) {
//     return response.json().then(data => {
//       // process your JSON data further
//     });
//   } else {
//     return response.text().then(text => {
//       // this is text, do something with it
//     });
//   }
// });
